import store from '../../store/';
import _ from 'lodash';
import GlobalConstants from '../../components/common/global.constants.js'
import UrlsConfig from "../../../config/urls.conf.js"

export function requireAuth(to, from, next) {

    let menuUrl = '/' + to.path.slice(1).split('/')[0];
    let menuList = store.state.GOV_MENU_AUTH;

    //메뉴정보가 없으면 이동하지 않음
    authCheck();
    // else {
    //     location.href = UrlsConfig.portalUrl;
    // }
    function authCheck() {
        //if(!_.isNil(store.state.svcMenuList)){
            if (!_.isNil(menuList) && menuList.length > 0) {
                let urlCheck = !_.isNil(_.find(menuList, {"menuUrl": menuUrl})) &&
                    _.isNil(
                        _.find(menuList, {"menuUrl": menuUrl, "authTypeCd" : GlobalConstants.AUTH_TYPE.NONE})
                    )
                ;

                if(urlCheck){  //'AUTH_TYPE_030': 수정권한, 'AUTH_TYPE_020': 조회권한, 'AUTH_TYPE_010': 권한없음
                    //권한이 존재할때만 진입
                    next();
                }
                else{
                    //해당 메뉴의 권한이 없을때 다른 메뉴가 존재하면 다음메뉴로 이동
                    let nextUrlList = _.find(menuList, { "authTypeCd" : "AUTH_TYPE_010"});
                    if(!_.isNil(nextUrlList) ){
                        next({path:nextUrlList.menuUrl});
                    }
                }
            } else {
                next();
            }
        // } else {
        //     setTimeout(function() {
        //         authCheck();
        //     }, 1)
        // }
    }

}



// WEBPACK FOOTER //
// ./src/components/common/AuthGuard.js